import type { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";

@Pipe({
    name: "objectValues"
}) export class ObjectValuesPipe implements PipeTransform {

    transform(value: any) {
        return value ? Object.values(value) : [];
    }
}